(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.paginationPosition = {
    attach: function attach(context, settings) {
      this.pagPosition();
    },

    pagPosition: function(){

      setTimeout(function(){
        // Pagination position
        var tableHeight = jQuery(".box-table").height();
        var filterHeight = jQuery(".filter-aside-wound-closure").height();

        if (filterHeight > tableHeight) {
          let resultHeightPagination = tableHeight - filterHeight;

          $('.pager-nav').css({
            'top': resultHeightPagination
          })

          $('.pager-nav').addClass('paginationPosition');

        }

      }, 1500);

    }

  };

})(jQuery, Drupal, drupalSettings);
